import React from 'react';
import { Mail, ArrowRightCircle } from 'lucide-react';

const stages = [
  { id: 'pending', label: 'Applied', color: 'bg-yellow-50 border-yellow-200' },
  { id: 'accepted', label: 'Accepted', color: 'bg-green-50 border-green-200' },
  { id: 'rejected', label: 'Rejected', color: 'bg-red-50 border-red-200' }
];

export default function PipelineBoard({ applications = [], onStatusChange, onReview }) {
  const handleDrop = (e, newStatus) => {
    e.preventDefault();
    const appId = e.dataTransfer.getData('text/plain');
    if (!appId) return;
    const app = applications.find(a => String(a.id) === String(appId));
    if (!app || app.status === newStatus) return;
    onStatusChange?.(app.id, newStatus);
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
      {stages.map(stage => {
        const items = applications.filter(app => (app.status || 'pending') === stage.id);
        return (
          <div
            key={stage.id}
            className={`rounded-lg border ${stage.color} p-3 min-h-[220px]`}
            onDragOver={(e) => e.preventDefault()}
            onDrop={(e) => handleDrop(e, stage.id)}
          >
            <div className="flex items-center justify-between mb-3">
              <h4 className="font-semibold text-gray-800">{stage.label}</h4>
              <span className="text-xs text-gray-600 bg-white px-2 py-0.5 rounded-full border">
                {items.length}
              </span>
            </div>

            <div className="space-y-2">
              {items.map(app => (
                <div
                  key={app.id}
                  draggable
                  onDragStart={(e) => e.dataTransfer.setData('text/plain', app.id)}
                  className="bg-white rounded-lg border border-gray-200 p-3 shadow-sm hover:shadow-md transition cursor-move"
                >
                  <div className="flex items-start justify-between gap-2">
                    <div>
                      <p className="font-medium text-gray-900">{app.name}</p>
                      <p className="text-xs text-gray-500">{new Date(app.created_at).toLocaleDateString()}</p>
                    </div>
                    <button
                      onClick={() => onReview?.(app)}
                      className="text-blue-600 hover:text-blue-800"
                      title="Review"
                    >
                      <ArrowRightCircle size={18} />
                    </button>
                  </div>

                  <div className="mt-2 flex items-center text-xs text-gray-600 gap-1">
                    <Mail size={12} />
                    <a href={`mailto:${app.email}`} className="hover:underline">
                      {app.email}
                    </a>
                  </div>
                </div>
              ))}

              {items.length === 0 && (
                <div className="text-sm text-gray-500 text-center py-6">No candidates</div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
